import { esc, safeHref } from '../utils/formatters';

const MOBILE_BREAKPOINT_PX = 768;
let activeCleanup = null;

function isMobile() {
    if (typeof window === 'undefined') return false;
    return window.matchMedia && window.matchMedia('(max-width: ' + MOBILE_BREAKPOINT_PX + 'px)').matches;
}

function createBackdrop() {
    const backdrop = document.createElement('div');
    backdrop.className = 'nm-disclaimer-backdrop';
    backdrop.setAttribute('role', 'presentation');
    return backdrop;
}

function closeAllDisclaimers() {
    if (activeCleanup) {
        const cleanup = activeCleanup;
        activeCleanup = null;
        cleanup();
    }
    document.querySelectorAll('.nm-disclaimer-backdrop, .nm-disclaimer-popover').forEach((el) => el.remove());
}

function openPopover(anchor, content) {
    closeAllDisclaimers();

    const popover = document.createElement('div');
    popover.className = 'nm-disclaimer-popover';
    popover.setAttribute('role', 'dialog');
    popover.setAttribute('aria-modal', 'false');
    popover.setAttribute('aria-label', 'Informacja o sygnałach społeczności');
    popover.innerHTML = content;

    document.body.appendChild(popover);

    const rect = anchor.getBoundingClientRect();
    const top = rect.bottom + window.scrollY + 8;
    const left = Math.max(8, Math.min(window.innerWidth - popover.offsetWidth - 8, rect.left + window.scrollX));
    popover.style.top = top + 'px';
    popover.style.left = left + 'px';

    const close = (restoreFocus) => {
        popover.remove();
        document.removeEventListener('click', onDocClick, true);
        document.removeEventListener('keydown', onKey, true);
        if (activeCleanup === cleanup) activeCleanup = null;
        if (restoreFocus) anchor.focus();
    };
    const cleanup = () => close(false);
    const onDocClick = (ev) => {
        if (popover.contains(ev.target) || anchor.contains(ev.target)) return;
        close(false);
    };
    const onKey = (ev) => {
        if (ev.key === 'Escape') {
            close(true);
        }
    };
    activeCleanup = cleanup;
    setTimeout(() => {
        document.addEventListener('click', onDocClick, true);
        document.addEventListener('keydown', onKey, true);
    }, 0);

    const firstFocusable = popover.querySelector('a, button');
    if (firstFocusable) firstFocusable.focus();
}

function openBottomSheet(anchor, content) {
    closeAllDisclaimers();

    const backdrop = createBackdrop();
    const sheet = document.createElement('div');
    sheet.className = 'nm-disclaimer-popover nm-disclaimer-popover--sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', 'Informacja o sygnałach społeczności');
    sheet.innerHTML = content
        + '<button type="button" class="ms-button ms-button--primary ms-button--block nm-primary-btn" data-disclaimer-close>Rozumiem</button>';

    document.body.appendChild(backdrop);
    document.body.appendChild(sheet);

    const close = (restoreFocus) => {
        backdrop.remove();
        sheet.remove();
        document.removeEventListener('keydown', onKey, true);
        if (activeCleanup === cleanup) activeCleanup = null;
        if (restoreFocus) anchor.focus();
    };
    const cleanup = () => close(false);
    const onKey = (ev) => { if (ev.key === 'Escape') close(true); };

    backdrop.addEventListener('click', () => close(true));
    sheet.querySelector('[data-disclaimer-close]').addEventListener('click', () => close(true));
    document.addEventListener('keydown', onKey, true);
    activeCleanup = cleanup;

    const firstFocusable = sheet.querySelector('button, a');
    if (firstFocusable) firstFocusable.focus();
}

export function initSignalsDisclaimer(options) {
    const opts = options || {};
    const body = opts.body || 'Sygnały dodają użytkownicy. Administrator nie ponosi odpowiedzialności za prawdziwość publikowanych treści.';
    const fullPolicyUrl = safeHref(opts.policyUrl || '/sygnaly-spolecznosci/regulamin');
    const fullPolicyLabel = opts.policyLabel || 'Zobacz pełen regulamin';
    const title = opts.title || 'Sygnały społeczności — informacja';

    const content = ''
        + '<h5 class="nm-disclaimer-popover__title">' + esc(title) + '</h5>'
        + '<p class="nm-disclaimer-popover__body">' + esc(body) + '</p>'
        + (fullPolicyUrl ? '<a class="nm-disclaimer-popover__link" href="' + esc(fullPolicyUrl) + '">' + esc(fullPolicyLabel) + '</a>' : '');

    document.addEventListener('click', (ev) => {
        const trigger = ev.target.closest('[data-signals-info]');
        if (!trigger) return;
        ev.preventDefault();
        ev.stopPropagation();
        if (isMobile()) {
            openBottomSheet(trigger, content);
        } else {
            openPopover(trigger, content);
        }
    });

    document.addEventListener('keydown', (ev) => {
        if (ev.key !== 'Enter' && ev.key !== ' ') return;
        const target = ev.target;
        if (!target || !target.matches || !target.matches('[data-signals-info]')) return;
        ev.preventDefault();
        if (isMobile()) {
            openBottomSheet(target, content);
        } else {
            openPopover(target, content);
        }
    });
}
